import { i18nConfig } from '@/app/i18nConfig';

export const getCurrentLocalePath = (locale: string | undefined) => {
  return locale && locale !== i18nConfig.defaultLocale ? `/${locale}` : '';
};

export const isLocaleSupported = (locale: string | undefined) => {
  return locale && i18nConfig.locales.includes(locale);
};
